import { FC, memo } from "react";
import { Paper } from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers-pro";
import { IAbsenceRequestDay } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import { IExcludedDay } from "src/Pages/Company/Absences/Calendars/Calendars.models";
import CustomCalendarDay from "./CustomCalendarPreviewDay";
import CustomCalendarHeader from "./CustomCalendarHeader";
import { getPaperStyles } from "./CalendarPreview.styles";

interface ICalendarPreviewProps {
  year: string;
  month: number;
  absenceRequestDays: IAbsenceRequestDay[];
  excludedDays: IExcludedDay[];
  plannedDays?: string[];
  disabled: boolean;
}

const CalendarPreview: FC<ICalendarPreviewProps> = ({
  year,
  month,
  absenceRequestDays = [],
  excludedDays = [],
  plannedDays,
  disabled = false,
}) => {
  const referenceDate = new Date().setFullYear(Number(year), month, 1);

  return (
    <Paper sx={(theme) => getPaperStyles(theme)}>
      <DateCalendar
        value={new Date(referenceDate)}
        views={["day"]}
        autoFocus={false}
        readOnly
        reduceAnimations
        disableHighlightToday
        dayOfWeekFormatter={(date: Date) =>
          date.toLocaleString("pl", { weekday: "short" })
        }
        slots={{
          calendarHeader: CustomCalendarHeader,
          day: (props) =>
            CustomCalendarDay({
              ...props,
              absenceRequestDays,
              excludedDays,
              plannedDays,
              disabled,
            }),
        }}
        data-testid="absences-calendar__datepicker"
      />
    </Paper>
  );
};

export default memo(CalendarPreview);
